import { InboxEditionComponent } from './../inboxsPanel/inbox.edition.component';
import { UserService } from './../../user.service';
import {
  UserProfileDTO, UserQueryDTO, QueryTypeDTO, createIdentifier, UserOrgsDTO, OrganizationalUnitDTO, InboxDTO
} from './../../api/plyca-dtos';

import { SubstitutionDTO } from './../../api/plyca-dtos-v2';
import { PaginationDTO } from './../../api/PaginationModel';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, Observer, of } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { generateRandomIdentifier } from '../../ui.service';
import { getSimpleIdentifierFromString, ProfileDTO, UserDTO } from '../../api/plyca-dtos';
import { PropertyService } from '../../properties/property.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { PersonEditionComponent } from './person.edition.component';
import * as lodash from 'lodash';

import { HelpType } from '../../components/common/help/help.service';
export class UserModel {

  dto: UserDTO;
  ui: any;
}

@Component({
  selector: 'user-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html',
  providers: [DialogService]
})
export class UserEditionComponent
  extends BaseFormComponent<UserDTO, UserModel>
  implements OnInit, OnDestroy {


  private identifier: string;
  readonly = false;
  operation: string;
  private properties = {};

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private propertyService: PropertyService,
    private plycaErrorHandler: PlycaErrorHandler,
    private router: Router,
    private userService: UserService,

    @Optional() protected activatedRoute: ActivatedRoute

  ) {
    super(elem);
    this.identifier = dialogConfig['id'];
    this.operation = dialogConfig['operation'];
    this.readonly = this.operation && this.operation == 'show';
    this.windowHash = generateRandomIdentifier();

  }

  ngOnInit(): void {
    this.subscribe(

      forkJoin([

        // 0
        this.propertyService.getProperty('ACTIVAR_SINCRONIZACION_USUARIO_BUZON', 'false')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        , // 1
        this.propertyService.getProperty('FraMtoUsuario.BntMtoComentariosFirma.Visible', '')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        , // 2
        this.propertyService.getProperty('ACTIVAR_GESTION_UNIDADES', 'false')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        , // 3
        this.propertyService.getProperty('FraMtoUsuario.AccesoSoporte.Checked', '')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ,
        // 4
        this.propertyService.getProperty('IntegracionPortafirmas.Activo', '')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        , // 5
        this.propertyService.getProperty('BLOQUEARFECHAFIRMA', '')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        , // 6
        this.propertyService.getProperty('PERFILESBLOQFECHAFIRMA', '')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          })),
        // 7
        this.propertyService.getProperty('MNTO_PERSONAS', 'false')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          })), // 8
        this.propertyService.getProperty('Adaptacion.ClassImpl.FraMtoUsuario', '')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
      ]).pipe(
        map(
          (prop: any[]) => {
            this.properties['ACTIVAR_SINCRONIZACION_USUARIO_BUZON'] = prop[0] == '1';
            this.properties['FraMtoUsuarioBntMtoComentariosFirmaVisible'] = prop[1] == '1';
            this.properties['ACTIVAR_GESTION_UNIDADES'] = prop[2] == 'true';
            this.properties['FraMtoUsuarioAccesoSoporteChecked'] = prop[3] == 'true';
            this.properties['IntegracionPortafirmasActivo'] = prop[4] == '1';
            this.properties['BLOQUEARFECHAFIRMA'] = prop[5] == 's' || prop[5] == 'S';
            this.properties['PERFILESBLOQFECHAFIRMA'] = prop[6];
            this.properties['MNTO_PERSONAS'] = prop[7] == 'true';
            this.properties['PROP_ADAPTACION_CLASSIMPL_FRAMTOUSUARIO'] = prop[8] == '1';
          }),
        finalize(() => {
          super.ngOnInit();
        })
      )
    )
  }

  protected postLoadForm(): Observable<any> {
    return this.propertyService.getProperty('2FA', '')
      .pipe(
        tap((value: string) => this.model.ui.twoFAEnabled = value === '1' || value === '2'),
        catchError((error: any) => {
          console.log(error)
          return of(undefined)
        }))
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  getFormSettingURL(): string {
    return 'admin/userISettings.json';
  }

  getServiceURL(operation?: string): string {

    if (operation === 'copy' || operation === 'insert' || operation === 'update') {
      return this.configuration.ADMIN_USER_SERVICE_URL;
    } else {
      return this.configuration.USER_SERVICE_URL;
    }

  }
  getObjectParams(): { [param: string]: string | string[]; } {
    return {

      'expand': 'expansionSet:manage'
    };
  }

  getObjectIdentifier(): string {
    return this.identifier;
  }


  dtoToModel(dto: UserDTO): Observable<any> {
    let model = new UserModel();
    // inicializacion de los campos del modelo utilizados por el json

    model.dto = dto;
    if (this.operation == 'copy') {
      model.dto.identifier = undefined;
      // model.dto.inboxes = [];
      // model.dto.userInboxes = [];
    }



    model['ui'] = {};
    model.ui['properties'] = {};
    model.ui['guestUser'] = false;
    model.ui['persons'] = [];
    model.ui['changePassword'] = false;
    if (model.dto.person) {
      model.ui.persons.push(model.dto.person);

    }
    model.ui.properties = this.properties;
    if (this.operation == 'insert' || this.operation == 'insert') {

      /*

             if(JACSilice.getPropertyBoolean("FraMtoUsuario.AccesoSoporte.Checked","0")) {
               jCheckBoxSoporte.setSelected(true);
             }
         */
      model.dto.accessSupport = model.ui.properties.FraMtoUsuarioAccesoSoporteChecked;
      model.dto.dateSignature = model.ui.properties.BLOQUEARFECHAFIRMA;
      model.ui.activoBLOQUEARFECHAFIRMA = this.userService.hasRoles(model.ui.properties.PERFILESBLOQFECHAFIRMA.replace(';', ','));
      //  jCheckBoxFechaFirma.setSelected(bSeleccionarCheck);
      //  jCheckBoxFechaFirma.setEnabled(bHabilitarCheck);



    }
    model.ui['operation'] = this.operation;
    let params: any = {};
    params.retrievAllProfilesApplicationData = true;




    if (model.dto?.userProfiles?.find(p => p?.profile?.identifier == '99') != undefined) {
      model.ui['guestUser'] = true;
      model.dto.userProfiles = [];
      model.dto.userQueries = [];
    } else {
      model.ui['guestUser'] = false;
    }

    return of(model);




  }



  modelToDTO(model: UserModel): UserDTO {


    let dto: UserDTO;
    dto = lodash.cloneDeep(model.dto);

    // Usuario invitado
    if (model.ui['guestUser'] == true) {
      // Se eliminan todos los perfiles exepto el invitado
      dto.userProfiles = [];
      let profile = new ProfileDTO();
      profile.application = 'CONTRATACION';
      profile.identifier = '99';

      let user = new UserDTO();
      user.identifier = dto.identifier;

      let userProfile =
        new UserProfileDTO();
      userProfile.application = 'CONTRATACION';
      userProfile.profile = profile;
      userProfile.user = user;

      dto.userProfiles.push(userProfile);
      // Se eliminan los tipo_QUERY
      dto.userQueries = [];


    }


    if (dto && dto.userOrgs) {
      dto.userOrgs = this.toUserOrgs(dto.userOrgs, dto.identifier);
    }

    if (dto?.customFields?.USUARIOS_ROL_INTEGRADOR === true) {
      dto.customFields.USUARIOS_ROL_INTEGRADOR = 1
    } else {
      if (!dto?.customFields) {
        dto.customFields = {}
      }
      if (!dto?.customFields?.USUARIOS_ROL_INTEGRADOR) {
        dto.customFields.USUARIOS_ROL_INTEGRADOR = {}
      }
      dto.customFields.USUARIOS_ROL_INTEGRADOR = 0
    }


    dto = JSON.parse(
      JSON.stringify(dto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return dto;

  }




  initHeaderActions() {
    if (!this.readonly) {
      this.subscribe(this.headerActionsService
        .addWindowAction('General.save', 'fas fa-save', 'btn-primary',
          true, this.windowHash),
        (success) => {
          if (this.operation == 'insert' || this.operation == 'copy') {
            if (this.model.ui['guestUser'] == true) {
              this.confirmationService.confirm({
                message: this.translationService.instant('ControlPanel.users.confirm.updateGuestUser'),
                accept: () => {
                  this.insertUser();
                }
              });
            } else {
              this.insertUser();
            }
          } else {
            if (this.model.dto.locked) {
              this.waitService.startWaiting(this.translate.instant('ControlPanel.users.actions.deactivateSubstitution.validate',
                { u: this.model.dto.identifier }) + '...');
              let now = new Date().getTime();
              this.subscribe(this.plycaService.query(this.configuration.SUBSTITUTIONS_SERVICE_URL,
                {
                  states: 'ACTIVE',
                  replacedUser: this.model.dto.identifier,
                  endDate: '' + now
                }).pipe(finalize(() => {

                  this.waitService.cancelWaiting();
                }
                )),
                (result: PaginationDTO<SubstitutionDTO>) => {
                  if (result?.content?.length > 0) {
                    let txt = this.translationService.instant('ControlPanel.users.confirm.blocked');
                    txt = txt + '<br/>' + this.translationService.instant('General.confirm.action.execute');
                    setTimeout(() => {
                      this.confirmationService.confirm({
                        message: txt,
                        accept: () => {
                          this.deactivateSubstitutions(result.content);
                        }
                      });
                    }, 200);

                  } else {
                    this.confirmUpdate();
                  }
                }
              );
            } else {
              this.confirmUpdate();
            }
          }
        }
      );

      this.subscribe(this.headerActionsService
        .addWindowAction('General.cancel', 'fas fa-times', 'btn-outline-secondary',
          true, this.windowHash),

        (success) => {

          this.cancel();


        });


    }
  }
  insertUser() {
    this.subscribe(this.insert(),
      (newUser: UserDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
          'success');
        this.ref.close(newUser);
      },
      (err) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
          'error');
        // Revisar ¿error de validación? Error 404
        // this.plycaErrorHandler.showServerError(err);
      })
  }

  confirmUpdate() {
    let mensaje = 'ControlPanel.users.confirm.update';
    if (this.model.ui['guestUser'] == true) {
      mensaje = 'ControlPanel.users.confirm.updateGuestUser';
    }


    setTimeout(() => {
      this.confirmationService.confirm({
        message: this.translationService.instant(mensaje),
        accept: () => {
          if (this.model.ui.properties.ACTIVAR_SINCRONIZACION_USUARIO_BUZON) {
            this.sincronizarBuzones();
          } else {
            this.updateUser();
          }
        }
      });
    }, 200);
  }


  deactivateSubstitutions(activeSubstitutions: SubstitutionDTO[]) {
    this.waitService.startWaiting(this.translate.instant('ControlPanel.users.actions.deactivateSubstitution.progress',
      { u: this.model.dto.identifier }) + '...');

    let error = false;
    activeSubstitutions.forEach(element => {
      element.enabled = false;
      this.subscribe(this.plycaService.patch<SubstitutionDTO>(this.configuration.SUBSTITUTIONS_SERVICE_URL, element),
        () => {
        },
        (err) => {
          this.waitService.cancelWaiting();
          this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
            'error');
          error = true;
        }

      );


    }
    );
    if (!error) {
      this.waitService.cancelWaiting();
      this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
        'success');
      this.confirmUpdate();
    }


  }


  sincronizarBuzones() {

    let mainInbox;
    if (this.model.dto.userInboxes) {
      mainInbox = this.model.dto.userInboxes.find((element) => element.main)
    }
    if (mainInbox) {
      this.waitService.startWaiting();
      this.subscribe(this.plycaService.get(this.configuration.INBOX_SERVICE_URL, mainInbox.inbox.identifier,
        {
          expand: 'usersWithAccess'
        }).pipe(finalize(() => {

          this.waitService.cancelWaiting();
        }
        )),
        (result: InboxDTO) => {

          if (result.usersWithAccess.length > 1) {
            let num = result.usersWithAccess.length;
            let txt = this.translationService.instant('ControlPanel.users.confirm.updateInbox', { num: num - 1 });
            if (num > 1) {
              txt = txt + '<br/>' + this.translationService.instant('ControlPanel.users.confirm.updateInbox2');
            } else {
              txt = txt + '<br/>' + this.translationService.instant('ControlPanel.users.confirm.updateInbox1');
            }
            txt = txt + '<br/>' + this.translationService.instant('General.confirm.action.execute');

            // Simulate slow network call
            // https://github.com/primefaces/primeng/issues/10589
            // workarround para que se vean el segundo diálog de confirmación
            setTimeout(() => {
              this.confirmationService.confirm({
                message: txt,
                accept: () => {
                  this.updateUser();

                }
              });

            }, 200) // Like above, but with a longer delay



          } else {
            this.updateUser();
          }

        }
      );

    } else {
      this.updateUser();
    }
  }
  updateUser() {
    this.subscribe(this.update(),
      (newUser: UserDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
          'success');
        this.ref.close(newUser);
      },
      (err) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
          'error');
        // Revisar ¿error de validación? Error 404
        // this.plycaErrorHandler.showServerError(err);
      })
  }

  public enablePasswordButton(): boolean {
    return !this.model.ui.changePassword;
  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.windowHash = this.windowHash;
    formConfig.readonly = this.readonly;
    formConfig.searchTags = [HelpType.EDIT_USER];





    formConfig.functions.push({
      identifier: 'editPerson',
      fn: this.editPerson.bind(this)
    });
    formConfig.functions.push({
      identifier: 'showPerson',
      fn: this.showPerson.bind(this)
    });
    formConfig.functions.push({
      identifier: 'addPerson',
      fn: this.addPerson.bind(this)
    });

    formConfig.functions.push({
      identifier: 'editComment',
      fn: this.editComment.bind(this)
    });

    formConfig.functions.push({
      identifier: 'mapQueryTypeResult',
      fn: this.mapQueryTypeResult
    });

    formConfig.functions.push({
      identifier: 'mapProfileResult',
      fn: this.mapProfileResult
    });

    formConfig.functions.push({
      identifier: 'mapInboxResult',
      fn: this.mapInboxResult
    });


    return of(formConfig);
  }






  modalError(error) {
    // this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }


  public cancel() {
    this.uiService.showSuccess(
      this.translate.instant('General.msg.cancel'),
      this.translate.instant('General.info'),
      'warn'
    );
    this.ref.close();

  }
  public noImplemented() {
    this.uiService.showSuccess(
      'Operación no implementada',
      this.translate.instant('General.info'),
      'warn'
    );

  }

  getHeaderInfo(): BaseFormHeaderInfo {
    throw new Error('Method not implemented.');
  }


  private toProfile(userProfiles: UserProfileDTO[], allProfiles: ProfileDTO[]): any {

    let list = [];

    userProfiles.map((element: UserProfileDTO) => {

      let profile: ProfileDTO;
      profile = new ProfileDTO();
      profile.identifier = createIdentifier(element.profile.identifier, element.application);
      profile.application = element.application;
      let result = allProfiles.find((el) => el.identifier === profile.identifier);
      if (result && result.description) {
        profile.description = element.profile.identifier + ' - '
          + allProfiles.find((el) => el.identifier === profile.identifier).description;
      } else {
        profile.description = element.profile.identifier;
      }



      list.push(profile);
    }

    );

    return list;
  }

  private toQueryType(userQueries: UserQueryDTO[], allQueries: QueryTypeDTO[]): any[] {

    let list = [];

    userQueries.map((element: UserQueryDTO) => {

      let query: QueryTypeDTO;
      query = new QueryTypeDTO();
      query.identifier = createIdentifier(element.query.identifier, element.application);
      query.application = element.application;
      query['userQueryID'] = element.identifier;
      query['description'] = element.query.identifier + ' - ' + allQueries.find((el) => el.identifier === query.identifier)?.description;


      list.push(query);
    }

    );
    return list;
  }
  toUserQueries(userQueries: UserQueryDTO[], usuid: string): UserQueryDTO[] {
    let list = [];

    userQueries.map((element) => {
      let userQuery: UserQueryDTO;
      let queryType: QueryTypeDTO;
      let user: UserDTO;

      element.identifier = getSimpleIdentifierFromString(element.identifier);

      queryType = new QueryTypeDTO();
      queryType.application = element.application;
      queryType.identifier = element.identifier;

      user = new UserDTO();
      user.identifier = usuid;

      userQuery =
        new UserQueryDTO();
      userQuery.application = element.application;
      userQuery.query = queryType;
      userQuery.user = user;
      if (element['userQueryID']) {
        userQuery.identifier = element['userQueryID'];
      }



      list.push(userQuery);
    }

    );

    return list;
  }

  toUserOrgs(userOrgs: UserOrgsDTO[], usuid: string): UserOrgsDTO[] {
    let list = [];

    userOrgs.map((element) => {

      let user = new UserDTO();
      user.identifier = usuid;
      let org = new OrganizationalUnitDTO();
      org.identifier = element.org.identifier;
      org.name = element.org.name;

      let userOrg = new UserOrgsDTO();
      userOrg.user = user;
      userOrg.org = org;

      userOrg.visibilityOnly = element.visibilityOnly;

      list.push(userOrg);
    }

    );

    return list;
  }

  getStringID(identifier: string) {
    let des = '';
    if (typeof identifier === 'string' && identifier.indexOf('<>') !== -1) {
      des = identifier.toString().substring(identifier.indexOf('>') + 1, identifier.length);
    }
    return des;
  }




  // Mantenimiento de personas
  showPerson(model: any) {
    this.personModalOpen(model, 'show');
  }
  addPerson(model: any) {
    this.personModalOpen(model, 'insert');
  }

  editPerson(model: any) {

    this.personModalOpen(model, 'update');
  }
  personModalOpen(model: any, operation: string) {

    let title = 'ControlPanel.person.actions.edit';
    if (operation == 'insert' || operation == 'copy') {
      title = 'ControlPanel.person.actions.new';
    }
    let config: DynamicDialogConfig = {
      header: this.translate.instant(title),
      width: '60%',
      styleClass: 'formEdition'

    };

    config['id'] = model?.dto?.person?.identifier;
    config['operation'] = operation;
    // config['readonly'] = readonly

    const dialog = this.dialogService.open(PersonEditionComponent, config);
    dialog.onClose.subscribe(person => {
      if (person) {
        this.model.dto.person = person;
      }



    });

  }



  editComment(model: any) {


    let title = 'ControlPanel.person.actions.edit';

    let config: DynamicDialogConfig = {
      header: this.translate.instant(title),
      width: '60%',
      styleClass: 'formEdition'

    };

    config['id'] = model.identifier;

    // config['readonly'] = readonly

    const dialog = this.dialogService.open(InboxEditionComponent, config);
    dialog.onClose.subscribe(person => {
      if (person) {
        this.model.dto.person = person;
      }



    });

  }




  sincronizationConfirm(num: number) {


    return new Observable((observer: Observer<boolean>) => {

    });
  }


  mapQueryTypeResult(model: any, result: any) {


    if (result && result[0]) {


      // Si ya hay elementos se filtran los que ya existen para no duplicar
      if (model.dto?.userQueries) {
        let r: any[];
        r = result.filter(f => {
          if (!model.dto.userQueries.find(i =>
            i.query.identifier === f.content.identifier.value
            && i.application === f.content.application.value)) {
            return f;
          }
        });

        result.splice(0);
        result.push(...r);
      }

      // Map to userQuery
      result.forEach(row => {
        row['properties'] = {};
        row['query'] = {};
        row['user'] = {};
        row['application'] = {}
        row.query['identifier'] = row.content.identifier.value;
        row.query['description'] = row.content.description.value;
        row['application'] = row.content.application.value;
        row.user['identifier'] = model?.dto?.identifier

        row.content = undefined;
        let arrayKeysExcept = ['query', 'application', 'user', 'properties'];
        Object.keys(row).forEach(
          function (key) {
            if (arrayKeysExcept.indexOf(key) === -1) {
              delete row[key];
            }
          });

      });



    } else {
      result['properties'] = {};
      result['query'] = {};
      result['user'] = {};
      result['application'] = {}
      result.query['identifier'] = result.content.identifier.value;
      result.query['description'] = result.content.description.value;
      result['application'] = result.content.application.value;
      result.user['identifier'] = model?.dto?.identifier

      result.content = undefined;
    }
  }


  mapInboxResult(model: any, result: any) {

    if (result && result[0]) {

      // Si ya hay elementos se filtran los que ya existen para no duplicar
      if (model.dto.userInboxes) {

        let r = result.filter(f => {
          if (!model.dto.userInboxes.find(i => i.inbox.identifier === f.identifier)) {
            return f;
          }
        })

        result.splice(0);
        result.push(...r);
      }

      // Map to userInbox
      result.forEach(row => {
        row['conditional'] = false;

        row['inbox'] = {};
        //  row['user'] = {};

        row.inbox['identifier'] = row.identifier;
        row.inbox['description'] = row.description;
        //  row.user['identifier'] = model?.dto;

        let arrayKeysExcept = ['inbox', 'conditional'];

        Object.keys(row).forEach(
          function (key) {
            if (arrayKeysExcept.indexOf(key) === -1) {
              delete row[key];
            }
          });

      });



    } else {
      result['inbox'] = {};
      //  result['user'] = {};

      result.inbox['identifier'] = result.identifier;
      result.inbox['description'] = result.description;
      //  result.user['identifier'] = model?.dto;



    }



  }



  mapProfileResult(model: any, result: any) {

    if (result && result[0]) {

      // Si ya hay elementos se filtran los que ya existen para no duplicar
      if (model.dto.userProfiles) {
        let r = result.filter(f => {
          if (!model.dto.userProfiles.find(i =>
            i.profile.identifier === f.content.identifier.value
            && i.application === f.content.application.value)) {
            return f;
          }
        });

        result.splice(0);
        result.push(...r);
      }

      // Map to userProfile
      result.forEach(row => {
        row['properties'] = {};
        row['profile'] = {};
        row['user'] = {};
        row['application'] = {}

        row.profile['identifier'] = row.content.identifier.value;
        row.profile['description'] = row.content.description.value;
        row['application'] = row.content.application.value;
        row.user['identifier'] = model?.dto?.identifier

        row.content = undefined;

        let arrayKeysExcept = ['profile', 'application', 'user', 'properties'];
        Object.keys(row).forEach(
          function (key) {
            if (arrayKeysExcept.indexOf(key) === -1) {
              delete row[key];
            }
          });

      });



    } else {
      result['properties'] = {};
      result['profile'] = {};
      result['user'] = {};
      result['application'] = {}

      result.profile['identifier'] = result.content.identifier.value;
      result.profile['description'] = result.content.description.value;
      result['application'] = result.content.application.value;
      result.user['identifier'] = model?.dto?.identifier

      result.content = undefined;
    }



  }
}
